
const getUrlParameter = (str) => {
  // console.log('!!!! getUrlParameter', str)
  str = str.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${str}=([^&#]*)`);
  const results = regex.exec(location.search);
  const param = results === null ? false : decodeURIComponent(results[1].replace(/\+/g, ' '));
  return param;
}

module.exports = {
  getUrlParameter,
}
